var render, staticRenderFns
import script from "./Article.vue?vue&type=script&lang=tsx&"
export * from "./Article.vue?vue&type=script&lang=tsx&"
import style0 from "./Article.vue?vue&type=style&index=0&id=c5844b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5844b04",
  null
  
)

export default component.exports